import { gql } from "@apollo/client";
import { CreatorData, ClientProfile, VendorProfile } from "@/graphql/fragments";

export const CHECK_TOKEN_QUERY = gql`
  query CheckSignupToken($token: String!) {
    isSignupTokenValid(token: $token) {
      success
      message
      emailFromToken
      user {
        id
        canBeAssignedTasks
        office {
          id
          city
          name
          isSignUpAgreementDisabled
          company {
            id
            profile {
              ...ClientProfile
              ...VendorProfile
            }
          }
        }
        inviter {
          id
          firstName
          lastName
          office {
            company {
              profile {
                ...ClientProfile
                ...VendorProfile
              }
            }
          }
        }
      }
    }
  }
  ${ClientProfile}
  ${VendorProfile}
`;

export const SIGNUP_MUTATION = gql`
  mutation NewUserSignup(
    $input: NewUserSignupInput
    $loginAfterSignup: Boolean
  ) {
    newUserSignup(input: $input, loginAfterSignup: $loginAfterSignup) {
      statusCode
      success
      message
      errors {
        field
        messages
      }
      user {
        id
        username
        ...CreatorData
      }
    }
  }

  ${CreatorData}
`;
